import { useRef } from 'react';
import { Menu } from '@mui/material';
import { MIconButton } from 'src/minimals/@material-extend';
import { useModal } from 'src/hooks/useModal';
import PopoverMenuContextProvider from './PopoverMenuContext';

const PopoverMenu = ({ renderButton, children, ...props }) => {
  const menuOpenerRef = useRef();
  const [open, , , toggleModal] = useModal();

  const openerComponentProps = { onClick: toggleModal, ref: menuOpenerRef };

  const opener =
    typeof renderButton === 'function' ? (
      renderButton({ ...openerComponentProps })
    ) : (
      <MIconButton {...openerComponentProps} />
    );

  const menuOptions =
    typeof children === 'function'
      ? children({ closeMenu: toggleModal })
      : children;

  return (
    <>
      {opener}
      <Menu
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        {...props}
        open={open}
        onClose={toggleModal}
        anchorEl={menuOpenerRef.current}
      >
        <PopoverMenuContextProvider value={{ closeMenu: toggleModal }}>
          {menuOptions}
        </PopoverMenuContextProvider>
      </Menu>
    </>
  );
};

export default PopoverMenu;
